import * as _ from 'lodash';
import * as moment from 'moment';
import { ClonableItem } from 'src/app/shared/models/clonable-item';
import { DATETIME_FORMAT } from 'src/app/shared/utils/utils';
import IInstance = ZoningAPI.IInstance;

export class Instance extends ClonableItem<IInstance> implements IInstance {
    Id: number;
    Name: string;
    State: string;
    LastOptimized: string;
    IsOptimizationRunning: boolean;
    PropertyRecordsCount: number;
    CalculationResultsCount: number;
    ZoningCodesCount: number;
    ZoningCodeVersionsCount: number;
    createdAt: string;
    updatedAt: string;

    isLoaded = false;

    lastOptimized: moment.Moment;
    lastOptimizedFormatted: string;
    updatedAtFormatted: string;

    initWithJSON(instanceData: IInstance) {
        Object.assign(
            this,
            _.pick(instanceData, [
                'Id',
                'Name',
                'State',
                'LastOptimized',
                'IsOptimizationRunning',
                'CalculationResultsCount',
                'PropertyRecordsCount',
                'ZoningCodesCount',
                'ZoningCodeVersionsCount',
                'updatedAt'
            ])
        );

        this.updatedAtFormatted = this.updatedAt ? moment(this.updatedAt).format(DATETIME_FORMAT) : this.updatedAt;

        this.lastOptimized = this.LastOptimized ? moment(this.LastOptimized) : null;
        this.lastOptimizedFormatted = this.IsOptimizationRunning
            ? 'In Progress'
            : this.LastOptimized
            ? moment(this.LastOptimized).format(DATETIME_FORMAT)
            : 'Not Optimized';
    }

    get isRecentlyOptimized(): boolean {
        return this.LastOptimized && this.lastOptimized > moment().subtract(1, 'month');
    }
}

export function InstanceFactory(data: IInstance) {
    return new Instance(data);
}
